import { type PrintAssetType, type PrintInitiation } from '../types/print.type';
import { useIsPrintDetectionEnabled } from './useIsPrintDetectionEnabled';
import { usePrinterConfig } from './usePrinterConfig';

// With the flag off, the workstations query runs only for connected or known machines, so a
// fetched query is enough proof that preferences are real. With the flag on the query runs for
// every account, and conciliatePreferences defaults a missing ShippingLabel to ClickToPrint.
// A workstation row matched to this machine is the proof instead.
export const useWorkstationInitiation = (
  assetType: PrintAssetType,
): PrintInitiation | undefined => {
  const isDetectionEnabled = useIsPrintDetectionEnabled();
  const { isWorkstationFetched, preferences, workstation } = usePrinterConfig();

  const hasWorkstationData = isDetectionEnabled ? Boolean(workstation) : isWorkstationFetched;

  return hasWorkstationData ? preferences[assetType]?.initiation : undefined;
};
